import { getLocalizedStrings } from  '../mfaPageLocalizedStrings';
const handleSendCodeHelperFirst = async (self, phoneNo) => {
    const { receiveCodeVia, sendCodeResponseObj = {} } = self.state;
    if (sendCodeResponseObj.factorId) {
        try {
            var reqObj = {
                factorId: sendCodeResponseObj.factorId,
                uid: sendCodeResponseObj.uid,
                oktaId: sendCodeResponseObj.oktaId,
                userType: sendCodeResponseObj.usertype
            };
            const res = await app.centralizedService.resendVerificationCode(reqObj);
            if (!res.status === 'success') {
                self.setState({ newEncryptedPhone: '' });
                throw { errorMsg: 'Send OTP failed', response: res };
            }
            self.setState({
                currentScreen: 'verify',
                showLoader: false, showError: false
            });
        } catch (error) {
            self.setState({
                showError: true,
                verifyErrMsg: 'Something went wrong on our end. Please Click "Resend Code" for a new code to be sent to your device. We appreciate your patience.',
                currentScreen: 'verify', showLoader: false
            });
        }
    } else {
        try {
            const rateAnalysisData = app.appService.getSessionstorage('RateAnalysisValidationData');
            const bpNumber = rateAnalysisData.businessPartnerNumber;
            let requestObj = {};
            requestObj.bpNumber = bpNumber;
            requestObj.factorType = receiveCodeVia === 'text' ? 'sms' : receiveCodeVia === 'email' ? 'email' : receiveCodeVia;
            requestObj.phoneNumber = phoneNo;
            let reqObj = { reqParams: requestObj };
            const res = await app.centralizedService.mfaGuestSendCode(reqObj);
            if (!res.status === 'success') {
                self.setState({ newEncryptedPhone: '' });
                throw { errorMsg: 'Send OTP failed', response: res };
            }
            self.setState({
                sendCodeResponseObj: res,
                currentScreen: 'verify',
                showLoader: false, showError: false
            });
        } catch (error) {
            self.setState({
                showError: true,
                verifyErrMsg: 'Something went wrong on our end. Please Click "Resend Code" for a new code to be sent to your device. We appreciate your patience.',
                currentScreen: 'verify', sendCodeResponseObj: error.response || {}, showLoader: false
            });
        }
    }
};

const isDisabled = (self) => {
    return (self.state.verifyErrorCode === 'OKTA_E0000069' || self.state.verifyErrorCode === 'OKTA_E0000047') ? true : false;
};

export const handleSendCodeHelper = async (self, phoneNo) => {
    if(isDisabled(self)){
        return;
    }
    const { userLoginInfoDetails, receiveCodeVia, sendCodeResponseObj = {} } = self.state;
    self.setState({ showLoader: true, verificationCode: '', phoneNo });
    if (self.props.rateChange && !app.appService.isAuthenticated() && location.pathname.includes("business")) {
        handleSendCodeHelperFirst(self, phoneNo);
    }
    else {
        try {
            const reqObj = {
                type: receiveCodeVia,
                oktaId: userLoginInfoDetails.oktaUid,
                encValue: phoneNo,
                value: userLoginInfoDetails.emailId,
                factors: self.props.factors ? true : false,
                txnName: (self.props.rateChange && !app.appService.isAuthenticated() && location.pathname.includes("rates-financing")) ? '' : 'login'
            };
            const preLoginEncryptPhone = app.appService.getSessionstorage('preLoginPhone') || [];
            if (app.appService.isAuthenticated() && preLoginEncryptPhone.includes(reqObj.encValue)) {
                reqObj['txnName'] = 'mfa';
            }
            const res = await app.centralizedService.twoFactorAuthSendCode(reqObj, sendCodeResponseObj);
            if (res.sendPinstatus === 'Failure') {
                self.setState({ newEncryptedPhone: '' });
                if (res.oktaUpdateStatus.errorCode === 'OKTA_E0000109' || res.oktaUpdateStatus.errorCode === 'OKTA_E0000133' || res.oktaUpdateStatus.errorCode === 'E0000150' || res.oktaUpdateStatus.errorCode === 'E0000151' || res.oktaUpdateStatus.errorCode === 'E0000118') {
                    throw { errorMsg: self.strings.sendCodeWaitError, response: res };
                }
                throw { errorMsg: self.strings.sendCodeGeneralError, response: res };
            }
            self.setState({
                sendCodeResponseObj: res,
                currentScreen: 'verify',
                showLoader: false, showError: false
            });
        } catch (error) {
            self.setState({
                showError: true,
                verifyErrMsg: error.errorMsg || self.strings.sendCodeGeneralError,
                currentScreen: 'verify', showLoader: false
            });
        }
    }
};

export const handleVerifyHelper = async (self) => {
    const { rateChange, onHandleRateSubmit = (() => { /* self is intentional */ }), disableTwoFaPopup = (() => { /* self is intentional */ }), rateChangeEvent } = self.props;
    const { receiveCodeVia, sendCodeResponseObj = {}, verificationCode } = self.state;
    const bpNumber = app.appService.getSessionstorage('RateAnalysisValidationData').businessPartnerNumber;
    try {
        var reqObj = receiveCodeVia === 'call' ?
          {
            verifyPin: verificationCode,
            factorId: sendCodeResponseObj.factorId,
            uid: sendCodeResponseObj.uid,
            oktaId: sendCodeResponseObj.oktaId,
            factorType: "call",
            phoneNumber: self.state.phoneNo,
            bpNumber: bpNumber,
          }
          : {
            verifyPin: verificationCode,
            factorId: sendCodeResponseObj.factorId,
            uid: sendCodeResponseObj.uid,
            oktaId: sendCodeResponseObj.oktaId,
            factorType: "sms",
            phoneNumber: self.state.phoneNo,
            bpNumber: bpNumber,
          };
        const res = await app.centralizedService.validVerifyCode(reqObj);
        if (res.status === 'success') {
          if (rateChange) {
            disableTwoFaPopup();
            rateChangeEvent && onHandleRateSubmit(rateChangeEvent);
            return;
          } else {
            throw new Error('Verification failed');
          }
        } else {
          throw new Error('Verification failed');
        }
      } catch (error) {
        self.setState({ showLoader: false, showError: true, verifyErrMsg: 'It looks like the code you’ve entered may have expired or is incorrect. Click "Resend Code" for a new code to be sent to your device.' });
      }
};

export const getVerifyErrMsg = (response) => {
    let errorCode;
    try {
        errorCode = response.oktaUpdateStatus[0].errorCode;
    } catch (err) {
        // this is intentional
    }

    let strings = getLocalizedStrings('TurnOnMFA');
    let verifyErrMsg = strings[errorCode] || strings.default;
    return { verifyErrMsg, errorCode };
};

export async function handleCancelHelper(){
    const { onClose = (() => { /* This is intentional */ }), onReopenParentPopup, fromPayment } = this.props;
      if (fromPayment) {
        this.handleGoToAccount();
        return;
      }
      if(this.state.verifyErrorCode === 'OKTA_E0000069'){
        await app.identityService.logout().then(res =>{
          app.identityService.handleUserLogout();
          app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.HOME_LOGIN);
        }).catch(() => {
          app.identityService.handleUserLogout();
          app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.HOME_LOGIN);
        });
        return;
      }
      onClose();
      if (onReopenParentPopup) {
        onReopenParentPopup();
      }

}

export function isNoExist(phoneNumber){
    return this.state.phoneNumbers.filter((data) => data.encryptedNumber === phoneNumber).length;
}
